import * as actionType from './actionTypes';

const initialState = {
  isInErrorState: false,
  commonLabel: null,
  asOfDate: null,
  notificationData: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_ERROR_PAGE:
      return {
        ...state,
        isInErrorState: true,
        commonLabel: action.payload
      };
    case actionType.CLEAR_ERROR_PAGE:
      return {
        ...state,
        isInErrorState: false,
        commonLabel: action.payload
      };
    case actionType.SET_AS_OF_DATE:
      localStorage.setItem('AS_OF_DATE', JSON.stringify(action.payload));
      return {
        ...state,
        isInErrorState: false,
        asOfDate: action.payload
      };
    case actionType.GET_NOTIFICATION_DATA:
      return {
        ...state,
        isInErrorState: false,
        notificationData: action.payload
      };
    default:
      return state;
  }
};


export default reducer;
